"use client";

import React, { type PropsWithChildren } from "react";

import { Chip } from "@mui/material";
import { SxProps } from "@mui/system";
import Box from "@mui/system/Box";

export function DynamicBlock({
  title,
  sx,
  children,
}: PropsWithChildren<{
  title: string;
  sx?: SxProps;
}>) {
  return (
    <Box
      position="relative"
      sx={{
        ...sx,
      }}
    >
      <Chip label={title} />
      <Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            p: 1,
            overflow: "hidden",
            position: "relative",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
